import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="security-info">
        <p><i className="fas fa-lock"></i> Ambiente 100% Seguro</p>
        <p className="small-text">Seus dados estão protegidos e criptografados</p>
      </div>
      <div className="payment-cards">
        <i className="fab fa-cc-visa"></i>
        <i className="fab fa-cc-mastercard"></i>
        <i className="fab fa-cc-amex"></i>
        <i className="fab fa-cc-diners-club"></i>
        <i className="fab fa-cc-jcb"></i>
        <i className="fab fa-cc-discover"></i>
        <i className="fab fa-pix"></i>
      </div>
      <div className="copyright">
        <p>&copy; 2025 INFINITY SOLUÇÕES - Todos os direitos reservados</p>
      </div>
    </footer>
  );
};

export default Footer;